export const modeOfTransport = [
    {
        "id": "OCEAN",
        "text": "1",
        "value": "OCEAN"
    },
    {
        "id": "AIR",
        "text": "2",
        "value": "AIR"
    },
    {
        "id": "TRUCK",
        "text": "3",
        "value": "TRUCK"
    },
    {
        "id": "RAIL",
        "text": "4",
        "value": "RAIL"
    },
    {
        "id": "NONE",
        "text": "5",
        "value": "NONE"
    },
]

export const canadianStates = [
{id:"XA",text:"Alberta",value:"XA", shorthand: "AB"},
{id:"XB",text:"New Brunswick",value:"XB", shorthand: "NB"},
{id:"XC",text:"British Columbia",value:"XC", shorthand: "BC"},
{id:"XM",text:"Manitoba",value:"XM", shorthand: "MB"},
{id:"XN",text:"Nova Scotia",value:"XN", shorthand: "NS"},
{id:"XO",text:"Ontario",value:"XO", shorthand: "ON"},
{id:"XP",text:"Prince Edward Island",value:"XP", shorthand: "PE"},
{id:"XQ",text:"Quebec",value:"XQ", shorthand: "QC"},
{id:"XS",text:"Saskatchewan",value:"XS", shorthand: "SK"},
{id:"XT",text:"Northwest Territories",value:"XT", shorthand: "NT"},
{id:"XV",text:"Nunavut",value:"XV", shorthand: "NU"},
{id:"XW",text:"Newfoundland",value:"XW", shorthand: "NL"},
{id:"XY",text:"Yukon Territory",value:"XY", shorthand: "YT"},
];

export const countryList = [
    {
        "id": "AF",
        "text": "Afghanistan",
        "value": "AF"
    }, {
        "id": "AL",
        "text": "Albania",
        "value": "AL"
    }, {
        "id": "DZ",
        "text": "Algeria",
        "value": "DZ"
    }, {
        "id": "AS",
        "text": "American Samoa",
        "value": "AS"
    }, {
        "id": "AD",
        "text": "Andorra",
        "value": "AD"
    }, {
        "id": "AO",
        "text": "Angola",
        "value": "AO"
    }, {
        "id": "AI",
        "text": "Anguilla",
        "value": "AI"
    }, {
        "id": "AQ",
        "text": "Antarctica",
        "value": "AQ"
    }, {
        "id": "AG",
        "text": "Antigua and Barbuda",
        "value": "AG"
    }, {
        "id": "AR",
        "text": "Argentina",
        "value": "AR"
    }, {
        "id": "AM",
        "text": "Armenia",
        "value": "AM"
    }, {
        "id": "AW",
        "text": "Aruba",
        "value": "AW"
    }, {
        "id": "AU",
        "text": "Australia",
        "value": "AU"
    }, {
        "id": "AT",
        "text": "Austria",
        "value": "AT"
    }, {
        "id": "AZ",
        "text": "Azerbaijan",
        "value": "AZ"
    }, {
        "id": "BS",
        "text": "Bahamas",
        "value": "BS"
    }, {
        "id": "BH",
        "text": "Bahrain",
        "value": "BH"
    }, {
        "id": "BD",
        "text": "Bangladesh",
        "value": "BD"
    }, {
        "id": "BB",
        "text": "Barbados",
        "value": "BB"
    }, {
        "id": "BY",
        "text": "Belarus",
        "value": "BY"
    }, {
        "id": "BE",
        "text": "Belgium",
        "value": "BE"
    }, {
        "id": "BZ",
        "text": "Belize",
        "value": "BZ"
    }, {
        "id": "BJ",
        "text": "Benin",
        "value": "BJ"
    }, {
        "id": "BM",
        "text": "Bermuda",
        "value": "BM"
    }, {
        "id": "BT",
        "text": "Bhutan",
        "value": "BT"
    }, {
        "id": "BO",
        "text": "Bolivia",
        "value": "BO"
    }, {
        "id": "BQ",
        "text": "Bonaire, Sint Eustatius and Saba",
        "value": "BQ"
    }, {
        "id": "BA",
        "text": "Bosnia and Herzegovina",
        "value": "BA"
    }, {
        "id": "BW",
        "text": "Botswana",
        "value": "BW"
    }, {
        "id": "BV",
        "text": "Bouvet Island",
        "value": "BV"
    }, {
        "id": "BR",
        "text": "Brazil",
        "value": "BR"
    }, {
        "id": "IO",
        "text": "British Indian Ocean Territory",
        "value": "IO"
    }, {
        "id": "VG",
        "text": "British Virgin Islands",
        "value": "VG"
    }, {
        "id": "BN",
        "text": "Brunei",
        "value": "BN"
    }, {
        "id": "BG",
        "text": "Bulgaria",
        "value": "BG"
    }, {
        "id": "BF",
        "text": "Burkina Faso",
        "value": "BF"
    }, {
        "id": "BI",
        "text": "Burundi",
        "value": "BI"
    }, {
        "id": "KH",
        "text": "Cambodia",
        "value": "KH"
    }, {
        "id": "CM",
        "text": "Cameroon",
        "value": "CM"
    }, {
        "id": "CA",
        "text": "Canada",
        "value": "CA"
    }, {
        "id": "CV",
        "text": "Cape Verde",
        "value": "CV"
    }, {
        "id": "KY",
        "text": "Cayman Islands",
        "value": "KY"
    }, {
        "id": "CF",
        "text": "Central African Republic",
        "value": "CF"
    }, {
        "id": "TD",
        "text": "Chad",
        "value": "TD"
    }, {
        "id": "CL",
        "text": "Chile",
        "value": "CL"
    }, {
        "id": "CN",
        "text": "China",
        "value": "CN"
    }, {
        "id": "CX",
        "text": "Christmas Island",
        "value": "CX"
    }, {
        "id": "CC",
        "text": "Cocos Islands",
        "value": "CC"
    }, {
        "id": "CO",
        "text": "Colombia",
        "value": "CO"
    }, {
        "id": "KM",
        "text": "Comoros",
        "value": "KM"
    }, {
        "id": "CG",
        "text": "Congo",
        "value": "CG"
    }, {
        "id": "CK",
        "text": "Cook Islands",
        "value": "CK"
    }, {
        "id": "CR",
        "text": "Costa Rica",
        "value": "CR"
    }, {
        "id": "HR",
        "text": "Croatia",
        "value": "HR"
    }, {
        "id": "CU",
        "text": "Cuba",
        "value": "CU"
    }, {
        "id": "CW",
        "text": "Curaçao",
        "value": "CW"
    }, {
        "id": "CY",
        "text": "Cyprus",
        "value": "CY"
    }, {
        "id": "CZ",
        "text": "Czech Republic",
        "value": "CZ"
    }, {
        "id": "CI",
        "text": "Côte d'Ivoire",
        "value": "CI"
    }, {
        "id": "DK",
        "text": "Denmark",
        "value": "DK"
    }, {
        "id": "DJ",
        "text": "Djibouti",
        "value": "DJ"
    }, {
        "id": "DM",
        "text": "Dominica",
        "value": "DM"
    }, {
        "id": "DO",
        "text": "Dominican Republic",
        "value": "DO"
    }, {
        "id": "EC",
        "text": "Ecuador",
        "value": "EC"
    }, {
        "id": "EG",
        "text": "Egypt",
        "value": "EG"
    }, {
        "id": "SV",
        "text": "El Salvador",
        "value": "SV"
    }, {
        "id": "GQ",
        "text": "Equatorial Guinea",
        "value": "GQ"
    }, {
        "id": "ER",
        "text": "Eritrea",
        "value": "ER"
    }, {
        "id": "EE",
        "text": "Estonia",
        "value": "EE"
    }, {
        "id": "ET",
        "text": "Ethiopia",
        "value": "ET"
    }, {
        "id": "FK",
        "text": "Falkland Islands",
        "value": "FK"
    }, {
        "id": "FO",
        "text": "Faroe Islands",
        "value": "FO"
    }, {
        "id": "FJ",
        "text": "Fiji",
        "value": "FJ"
    }, {
        "id": "FI",
        "text": "Finland",
        "value": "FI"
    }, {
        "id": "FR",
        "text": "France",
        "value": "FR"
    }, {
        "id": "GF",
        "text": "French Guiana",
        "value": "GF"
    }, {
        "id": "PF",
        "text": "French Polynesia",
        "value": "PF"
    }, {
        "id": "TF",
        "text": "French Southern Territories",
        "value": "TF"
    }, {
        "id": "GA",
        "text": "Gabon",
        "value": "GA"
    }, {
        "id": "GM",
        "text": "Gambia",
        "value": "GM"
    }, {
        "id": "GE",
        "text": "Georgia",
        "value": "GE"
    }, {
        "id": "DE",
        "text": "Germany",
        "value": "DE"
    }, {
        "id": "GH",
        "text": "Ghana",
        "value": "GH"
    }, {
        "id": "GI",
        "text": "Gibraltar",
        "value": "GI"
    }, {
        "id": "GR",
        "text": "Greece",
        "value": "GR"
    }, {
        "id": "GL",
        "text": "Greenland",
        "value": "GL"
    }, {
        "id": "GD",
        "text": "Grenada",
        "value": "GD"
    }, {
        "id": "GP",
        "text": "Guadeloupe",
        "value": "GP"
    }, {
        "id": "GU",
        "text": "Guam",
        "value": "GU"
    }, {
        "id": "GT",
        "text": "Guatemala",
        "value": "GT"
    }, {
        "id": "GG",
        "text": "Guernsey",
        "value": "GG"
    }, {
        "id": "GN",
        "text": "Guinea",
        "value": "GN"
    }, {
        "id": "GW",
        "text": "Guinea-Bissau",
        "value": "GW"
    }, {
        "id": "GY",
        "text": "Guyana",
        "value": "GY"
    }, {
        "id": "HT",
        "text": "Haiti",
        "value": "HT"
    }, {
        "id": "HM",
        "text": "Heard Island And McDonald Islands",
        "value": "HM"
    }, {
        "id": "HN",
        "text": "Honduras",
        "value": "HN"
    }, {
        "id": "HK",
        "text": "Hong Kong",
        "value": "HK"
    }, {
        "id": "HU",
        "text": "Hungary",
        "value": "HU"
    }, {
        "id": "IS",
        "text": "Iceland",
        "value": "IS"
    }, {
        "id": "IN",
        "text": "India",
        "value": "IN"
    }, {
        "id": "ID",
        "text": "Indonesia",
        "value": "ID"
    }, {
        "id": "IR",
        "text": "Iran",
        "value": "IR"
    }, {
        "id": "IQ",
        "text": "Iraq",
        "value": "IQ"
    }, {
        "id": "IE",
        "text": "Ireland",
        "value": "IE"
    }, {
        "id": "IM",
        "text": "Isle Of Man",
        "value": "IM"
    }, {
        "id": "IL",
        "text": "Israel",
        "value": "IL"
    }, {
        "id": "IT",
        "text": "Italy",
        "value": "IT"
    }, {
        "id": "JM",
        "text": "Jamaica",
        "value": "JM"
    }, {
        "id": "JP",
        "text": "Japan",
        "value": "JP"
    }, {
        "id": "JE",
        "text": "Jersey",
        "value": "JE"
    }, {
        "id": "JO",
        "text": "Jordan",
        "value": "JO"
    }, {
        "id": "KZ",
        "text": "Kazakhstan",
        "value": "KZ"
    }, {
        "id": "KE",
        "text": "Kenya",
        "value": "KE"
    }, {
        "id": "KI",
        "text": "Kiribati",
        "value": "KI"
    }, {
        "id": "KW",
        "text": "Kuwait",
        "value": "KW"
    }, {
        "id": "KG",
        "text": "Kyrgyzstan",
        "value": "KG"
    }, {
        "id": "LA",
        "text": "Laos",
        "value": "LA"
    }, {
        "id": "LV",
        "text": "Latvia",
        "value": "LV"
    }, {
        "id": "LB",
        "text": "Lebanon",
        "value": "LB"
    }, {
        "id": "LS",
        "text": "Lesotho",
        "value": "LS"
    }, {
        "id": "LR",
        "text": "Liberia",
        "value": "LR"
    }, {
        "id": "LY",
        "text": "Libya",
        "value": "LY"
    }, {
        "id": "LI",
        "text": "Liechtenstein",
        "value": "LI"
    }, {
        "id": "LT",
        "text": "Lithuania",
        "value": "LT"
    }, {
        "id": "LU",
        "text": "Luxembourg",
        "value": "LU"
    }, {
        "id": "MO",
        "text": "Macao",
        "value": "MO"
    }, {
        "id": "MK",
        "text": "Macedonia",
        "value": "MK"
    }, {
        "id": "MG",
        "text": "Madagascar",
        "value": "MG"
    }, {
        "id": "MW",
        "text": "Malawi",
        "value": "MW"
    }, {
        "id": "MY",
        "text": "Malaysia",
        "value": "MY"
    }, {
        "id": "MV",
        "text": "Maldives",
        "value": "MV"
    }, {
        "id": "ML",
        "text": "Mali",
        "value": "ML"
    }, {
        "id": "MT",
        "text": "Malta",
        "value": "MT"
    }, {
        "id": "MH",
        "text": "Marshall Islands",
        "value": "MH"
    }, {
        "id": "MQ",
        "text": "Martinique",
        "value": "MQ"
    }, {
        "id": "MR",
        "text": "Mauritania",
        "value": "MR"
    }, {
        "id": "MU",
        "text": "Mauritius",
        "value": "MU"
    }, {
        "id": "YT",
        "text": "Mayotte",
        "value": "YT"
    }, {
        "id": "MX",
        "text": "Mexico",
        "value": "MX"
    }, {
        "id": "FM",
        "text": "Micronesia",
        "value": "FM"
    }, {
        "id": "MD",
        "text": "Moldova",
        "value": "MD"
    }, {
        "id": "MC",
        "text": "Monaco",
        "value": "MC"
    }, {
        "id": "MN",
        "text": "Mongolia",
        "value": "MN"
    }, {
        "id": "ME",
        "text": "Montenegro",
        "value": "ME"
    }, {
        "id": "MS",
        "text": "Montserrat",
        "value": "MS"
    }, {
        "id": "MA",
        "text": "Morocco",
        "value": "MA"
    }, {
        "id": "MZ",
        "text": "Mozambique",
        "value": "MZ"
    }, {
        "id": "MM",
        "text": "Myanmar",
        "value": "MM"
    }, {
        "id": "NA",
        "text": "Namibia",
        "value": "NA"
    }, {
        "id": "NR",
        "text": "Nauru",
        "value": "NR"
    }, {
        "id": "NP",
        "text": "Nepal",
        "value": "NP"
    }, {
        "id": "NL",
        "text": "Netherlands",
        "value": "NL"
    }, {
        "id": "AN",
        "text": "Netherlands Antilles",
        "value": "AN"
    }, {
        "id": "NC",
        "text": "New Caledonia",
        "value": "NC"
    }, {
        "id": "NZ",
        "text": "New Zealand",
        "value": "NZ"
    }, {
        "id": "NI",
        "text": "Nicaragua",
        "value": "NI"
    }, {
        "id": "NE",
        "text": "Niger",
        "value": "NE"
    }, {
        "id": "NG",
        "text": "Nigeria",
        "value": "NG"
    }, {
        "id": "NU",
        "text": "Niue",
        "value": "NU"
    }, {
        "id": "NF",
        "text": "Norfolk Island",
        "value": "NF"
    }, {
        "id": "KP",
        "text": "North Korea",
        "value": "KP"
    }, {
        "id": "MP",
        "text": "Northern Mariana Islands",
        "value": "MP"
    }, {
        "id": "NO",
        "text": "Norway",
        "value": "NO"
    }, {
        "id": "OM",
        "text": "Oman",
        "value": "OM"
    }, {
        "id": "PK",
        "text": "Pakistan",
        "value": "PK"
    }, {
        "id": "PW",
        "text": "Palau",
        "value": "PW"
    }, {
        "id": "PS",
        "text": "Palestine",
        "value": "PS"
    }, {
        "id": "PA",
        "text": "Panama",
        "value": "PA"
    }, {
        "id": "PG",
        "text": "Papua New Guinea",
        "value": "PG"
    }, {
        "id": "PY",
        "text": "Paraguay",
        "value": "PY"
    }, {
        "id": "PE",
        "text": "Peru",
        "value": "PE"
    }, {
        "id": "PH",
        "text": "Philippines",
        "value": "PH"
    }, {
        "id": "PN",
        "text": "Pitcairn",
        "value": "PN"
    }, {
        "id": "PL",
        "text": "Poland",
        "value": "PL"
    }, {
        "id": "PT",
        "text": "Portugal",
        "value": "PT"
    }, {
        "id": "PR",
        "text": "Puerto Rico",
        "value": "PR"
    }, {
        "id": "QA",
        "text": "Qatar",
        "value": "QA"
    }, {
        "id": "RE",
        "text": "Reunion",
        "value": "RE"
    }, {
        "id": "RO",
        "text": "Romania",
        "value": "RO"
    }, {
        "id": "RU",
        "text": "Russia",
        "value": "RU"
    }, {
        "id": "RW",
        "text": "Rwanda",
        "value": "RW"
    }, {
        "id": "BL",
        "text": "Saint Barthélemy",
        "value": "BL"
    }, {
        "id": "SH",
        "text": "Saint Helena",
        "value": "SH"
    }, {
        "id": "KN",
        "text": "Saint Kitts And Nevis",
        "value": "KN"
    }, {
        "id": "LC",
        "text": "Saint Lucia",
        "value": "LC"
    }, {
        "id": "MF",
        "text": "Saint Martin",
        "value": "MF"
    }, {
        "id": "PM",
        "text": "Saint Pierre And Miquelon",
        "value": "PM"
    }, {
        "id": "VC",
        "text": "Saint Vincent And The Grenadines",
        "value": "VC"
    }, {
        "id": "WS",
        "text": "Samoa",
        "value": "WS"
    }, {
        "id": "SM",
        "text": "San Marino",
        "value": "SM"
    }, {
        "id": "ST",
        "text": "Sao Tome And Principe",
        "value": "ST"
    }, {
        "id": "SA",
        "text": "Saudi Arabia",
        "value": "SA"
    }, {
        "id": "SN",
        "text": "Senegal",
        "value": "SN"
    }, {
        "id": "RS",
        "text": "Serbia",
        "value": "RS"
    }, {
        "id": "SC",
        "text": "Seychelles",
        "value": "SC"
    }, {
        "id": "SL",
        "text": "Sierra Leone",
        "value": "SL"
    }, {
        "id": "SG",
        "text": "Singapore",
        "value": "SG"
    }, {
        "id": "SX",
        "text": "Sint Maarten (Dutch part)",
        "value": "SX"
    }, {
        "id": "SK",
        "text": "Slovakia",
        "value": "SK"
    }, {
        "id": "SI",
        "text": "Slovenia",
        "value": "SI"
    }, {
        "id": "SB",
        "text": "Solomon Islands",
        "value": "SB"
    }, {
        "id": "SO",
        "text": "Somalia",
        "value": "SO"
    }, {
        "id": "ZA",
        "text": "South Africa",
        "value": "ZA"
    }, {
        "id": "GS",
        "text": "South Georgia And The South Sandwich Islands",
        "value": "GS"
    }, {
        "id": "KR",
        "text": "South Korea",
        "value": "KR"
    }, {
        "id": "SS",
        "text": "South Sudan",
        "value": "SS"
    }, {
        "id": "ES",
        "text": "Spain",
        "value": "ES"
    }, {
        "id": "LK",
        "text": "Sri Lanka",
        "value": "LK"
    }, {
        "id": "SD",
        "text": "Sudan",
        "value": "SD"
    }, {
        "id": "SR",
        "text": "Suriname",
        "value": "SR"
    }, {
        "id": "SJ",
        "text": "Svalbard And Jan Mayen",
        "value": "SJ"
    }, {
        "id": "SZ",
        "text": "Swaziland",
        "value": "SZ"
    }, {
        "id": "SE",
        "text": "Sweden",
        "value": "SE"
    }, {
        "id": "CH",
        "text": "Switzerland",
        "value": "CH"
    }, {
        "id": "SY",
        "text": "Syria",
        "value": "SY"
    }, {
        "id": "TW",
        "text": "Taiwan",
        "value": "TW"
    }, {
        "id": "TJ",
        "text": "Tajikistan",
        "value": "TJ"
    }, {
        "id": "TZ",
        "text": "Tanzania",
        "value": "TZ"
    }, {
        "id": "TH",
        "text": "Thailand",
        "value": "TH"
    }, {
        "id": "CD",
        "text": "The Democratic Republic Of Congo",
        "value": "CD"
    }, {
        "id": "TL",
        "text": "Timor-Leste",
        "value": "TL"
    }, {
        "id": "TG",
        "text": "Togo",
        "value": "TG"
    }, {
        "id": "TK",
        "text": "Tokelau",
        "value": "TK"
    }, {
        "id": "TO",
        "text": "Tonga",
        "value": "TO"
    }, {
        "id": "TT",
        "text": "Trinidad and Tobago",
        "value": "TT"
    }, {
        "id": "TN",
        "text": "Tunisia",
        "value": "TN"
    }, {
        "id": "TR",
        "text": "Turkey",
        "value": "TR"
    }, {
        "id": "TM",
        "text": "Turkmenistan",
        "value": "TM"
    }, {
        "id": "TC",
        "text": "Turks And Caicos Islands",
        "value": "TC"
    }, {
        "id": "TV",
        "text": "Tuvalu",
        "value": "TV"
    }, {
        "id": "VI",
        "text": "U.S. Virgin Islands",
        "value": "VI"
    }, {
        "id": "UG",
        "text": "Uganda",
        "value": "UG"
    }, {
        "id": "UA",
        "text": "Ukraine",
        "value": "UA"
    }, {
        "id": "AE",
        "text": "United Arab Emirates",
        "value": "AE"
    }, {
        "id": "GB",
        "text": "United Kingdom",
        "value": "GB"
    }, {
        "id": "US",
        "text": "United States",
        "value": "US"
    }, {
        "id": "UM",
        "text": "United States Minor Outlying Islands",
        "value": "UM"
    }, {
        "id": "UY",
        "text": "Uruguay",
        "value": "UY"
    }, {
        "id": "UZ",
        "text": "Uzbekistan",
        "value": "UZ"
    }, {
        "id": "VU",
        "text": "Vanuatu",
        "value": "VU"
    }, {
        "id": "VA",
        "text": "Vatican",
        "value": "VA"
    }, {
        "id": "VE",
        "text": "Venezuela",
        "value": "VE"
    }, {
        "id": "VN",
        "text": "Vietnam",
        "value": "VN"
    }, {
        "id": "WF",
        "text": "Wallis And Futuna",
        "value": "WF"
    }, {
        "id": "EH",
        "text": "Western Sahara",
        "value": "EH"
    }, {
        "id": "YE",
        "text": "Yemen",
        "value": "YE"
    }, {
        "id": "ZM",
        "text": "Zambia",
        "value": "ZM"
    }, {
        "id": "ZW",
        "text": "Zimbabwe",
        "value": "ZW"
    }, {
        "id": "AX",
        "text": "Åland Islands",
        "value": "AX"
    }];

    